// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"27": "7f4373777ed7a11c","960": "27ea5e363c494259",}[chunkId] + ".js"
}